import { render } from "./RntrcPreco.vue?vue&type=template&id=fd21fa6a&scoped=true"
import script from "./RntrcPreco.vue?vue&type=script&lang=ts"
export * from "./RntrcPreco.vue?vue&type=script&lang=ts"

import "./RntrcPreco.vue?vue&type=style&index=0&id=fd21fa6a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fd21fa6a"

export default script